// pages/Gallery/styles.js
import styled from 'styled-components';
import { Container } from '../../styles/components';

export const GalleryWrapper = styled.div`
    min-height: calc(100vh - 64px);
    background: ${props => props.theme.colors.background.alt};
`;

export const GalleryHeader = styled.div`
    background: white;
    padding: ${props => props.theme.spacing['4xl']} 0;
    margin-bottom: ${props => props.theme.spacing.xxl};
    text-align: center;
    border-bottom: 1px solid ${props => props.theme.colors.border};
`;

export const HeaderContent = styled(Container)`
    h1 {
        font-size: ${props => props.theme.typography.sizes['3xl']};
        color: ${props => props.theme.colors.primary.dark};
        margin-bottom: ${props => props.theme.spacing.md};
        font-family: 'Playfair Display', serif; // Make sure this font is imported
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        font-size: ${props => props.theme.typography.sizes.lg};
        max-width: 600px;
        margin: 0 auto;
    }
`;